<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_240_2623)">
      <path
        d="M22.9014 4H26.5816L18.5415 14.1662L28 28H20.5941L14.7935 19.6098L8.15631 28H4.47393L13.0736 17.1262L4 4H11.5939L16.8372 11.6689L22.9014 4ZM21.6098 25.5631H23.649L10.4859 6.30892H8.29759L21.6098 25.5631Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_240_2623">
        <rect fill="white" height="32" width="32" />
      </clipPath>
    </defs>
  </svg>
</template>
